'use client'

import { cn } from '@morpho-org/ui-v6/utils'
import { type ForwardedRef, forwardRef, type InputHTMLAttributes } from 'react'

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  suffix?: React.ReactNode
  wrapperClassName?: string
}

const wrapperStyles = cn([
  'px-xs gap-2xs flex h-[26px] min-w-0 items-center',
  'bg-muted rounded-lg',
  'focus-within:outline-border focus-within:outline-1'
])

const inputStyles = cn([
  'min-w-0 flex-1',
  'bg-transparent',
  'border-none outline-none',
  'text-3xs text-foreground placeholder:text-muted-foreground'
])

const Input = (
  { suffix, wrapperClassName, className, ...props }: InputProps,
  ref: ForwardedRef<HTMLInputElement>
) => {
  return (
    <div className={cn(wrapperStyles, wrapperClassName)}>
      <input ref={ref} className={cn(inputStyles, className)} {...props} />
      {suffix && <span className="text-3xs text-muted-foreground">{suffix}</span>}
    </div>
  )
}

const ForwardedInput = forwardRef(Input)
ForwardedInput.displayName = 'Input'

export { ForwardedInput as Input }
